import React from "react";

const PageModIntro = (props) => {
  const { pageModIntro } = props;
  return (
    <div className="row page-mod-intro-text mt-4 pt-4">
      {pageModIntro.map((item, index) => (
        <div className="col-md-4" key={index}>
          <h6 className="font-20 font-w500 mt-4 mb-2 text-center">
            {item.title}
          </h6>
          <p className="text-center">{item.description}</p>
        </div>
      ))}
    </div>
  );
};

export default PageModIntro;
